import React, { useEffect, useState } from "react";
import "./BankTransfer.css";
import successImage from "./success3.png";
import {
  fetchFromAccounts,
  fetchToAccounts,
  fetchBank2AccountDetails,
  submitTransaction2,
  fetchTag1Api,
} from "./services/api";
import { handleTruncateApi, handleInsertApi } from "./services/api";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa"; // Import the required icons
import { useNavigate } from "react-router-dom";

function BankTransfer2to3new() {
  const [fromAccounts, setFromAccounts] = useState([]);
  const [toAccounts, setToAccounts] = useState([]);
  const [formData, setFormData] = useState({
    fromAccount: "",
    toAccount: "",
    amount: "",
    transferType: "",
    transactionMode: "",
  });
  const [responseMessage, setResponseMessage] = useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [transactionDetails, setTransactionDetails] = useState({
    accountNumber: "",
    availableBalance: "",
  });
  const [transferredAmount, setTransferredAmount] = useState("");
  const [transactionSubmitted, setTransactionSubmitted] = useState(false);
  // New state for storing box data
  const [box1Data, setBox1Data] = useState({});
  const [box2Data, setBox2Data] = useState({});
  const [tag1Data, setTag1Data] = useState("");
  const [loading, setLoading] = useState(false); // Loader state for Truncate API
  const [loading1, setLoading1] = useState(false); // Loader state for Insert API
  const [status, setStatus] = useState(null);
  const [status1, setStatus1] = useState(null);

  useEffect(() => {
    document.title = "TAGER AI-Bank2to3"; // Set the page title for this route
  }, []);

  useEffect(() => {
    fetchFromAccounts()
      .then((data) => {
        setFromAccounts(data);
        if (data.length > 0) {
          setFormData((prev) => ({
            ...prev,
            fromAccount: data[0], // Automatically set the first account as default
          }));
        }
      })
      .catch((error) => console.error("Error fetching from accounts:", error));
  }, []);

  useEffect(() => {
    fetchToAccounts()
      .then((data) => setToAccounts(data))
      .catch((error) => console.error("Error fetching to accounts:", error));
  }, []);

  useEffect(() => {
    fetchBank2AccountDetails()
      .then((data) => {
        if (data.length > 0) {
          setTransactionDetails({
            accountNumber: data[0].accountNumber,
            availableBalance: data[0].availableBalance,
          });
        }
      })
      .catch((error) =>
        console.error("Error fetching Bank 2 account details:", error)
      );
  }, []);

  useEffect(() => {
    const fetchTag1 = async () => {
      try {
        const tag1 = await fetchTag1Api(); // Call the API
        setTag1Data(tag1); // Set the tag1 data
      } catch (error) {
        console.error("Error fetching tag1 data:", error);
      }
    };

    fetchTag1(); // Trigger the fetch on component mount
  }, []);
  // Function to call the truncate API
  const handleTruncate = async () => {
    setLoading(true); // Show loader
    try {
      const status = await handleTruncateApi();
      setStatus(status);
      setTimeout(() => setStatus(null), 1000);
    } catch (error) {
      console.error("Error during truncate operation:", error);
    } finally {
      setLoading(false); // Hide loader
    }
  };

  // Function to call the insert-data API
  const handleInsert = async () => {
    setLoading1(true); // Show loader
    try {
      const status1 = await handleInsertApi();
      setStatus1(status1);
      setTimeout(() => setStatus1(null), 1000);
    } catch (error) {
      console.error("Error during insert operation:", error);
    } finally {
      setLoading1(false); // Hide loader
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "amount") {
      // Remove any non-numeric characters (excluding commas)
      const numericValue = value.replace(/[^0-9]/g, "");

      // Format the number for display with commas
      const formattedValue = formatNumberWithCommas(numericValue);

      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const formatNumberWithCommas = (value) => {
    if (value == null || isNaN(value)) {
      return ""; // Return an empty string for invalid values
    }

    value = value.toString(); // Convert the value to a string to avoid type errors

    // Remove all non-numeric characters
    value = value.replace(/[^0-9]/g, "");

    // Handle Indian number system formatting
    if (value.length > 3) {
      let lastThree = value.slice(-3); // Get the last three digits
      let otherNumbers = value.slice(0, value.length - 3); // Get the rest of the number

      // Format the first part with a comma every two digits
      otherNumbers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");

      // Join the formatted parts
      return otherNumbers + "," + lastThree;
    }

    // If the number is less than 1000, just return the value
    return value;
  };
  // Function to get the cleaned number without commas for payload
  const getCleanedAmount = () => {
    return formData.amount.replace(/,/g, "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Clear previous response before submitting a new transaction
    setResponseMessage("");
    setTransferredAmount("");
    setTransactionDetails({
      accountNumber: "", // Reset only the details if necessary
      availableBalance: "", // Keep it empty until updated after a successful transaction
    });

    submitTransaction2(
      formData,
      getCleanedAmount,
      setResponseMessage,
      setTransferredAmount,
      setTransactionDetails,
      setBox1Data,
      setBox2Data,
      setTransactionSubmitted,
      setReferenceNumber, // Pass the state function to update reference number
      setTag1Data
    );
  };

  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleLogout = () => {
    // Clear login status from localStorage
    localStorage.removeItem("isLoggedIn");

    // Notify other tabs about logout
    localStorage.setItem("logout-event", Date.now());

    // Redirect to LoginPage (forces reload in all tabs)
    window.location.href = "/";
  };


  return (
    <>
      <h1 className="main-title">
        Creating Reference Loop Tag
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </h1>

      {/* Left Side: Tag 1 Data */}
      {/* Left Side: Tag 1 Data */}
      <div className="col-2 tag-container">
        {tag1Data ? (
          <>
            <button className="top-buttonnew2">Bank 1</button>
            <div className="tag-responseprevious1new">
              <p>53-234de-ndgh-bqzj</p>
            </div>
            {/* Downward Arrow and Another Section */}
            <div
              style={{
                textAlign: "center",
                margin: "5px 0",
                marginLeft: "-85px", // Moves the arrow 10px to the left
              }}>
              <span style={{ fontSize: "60px", color: "#000" }}>↓</span>
              {/* Down arrow */}
            </div>

            <button className="top-buttonnew2">Bank 2</button>
            <div className="tag-responseprevious1new">
              <p>53-234de-ndgh-bqzj</p>{" "}
              {/* Replace with new data if different */}
            </div>
          </>
        ) : (
          // Placeholder to maintain layout consistency
          <div
            style={{
              height: "266px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}></div>
        )}
      </div>

      <div
        className="row"
        style={{ marginTop: "-185px", position: "relative" }}>
        <div className="col-6">
          <div className="box_wrp">
            <div className=" top_btn_wrp1 mx-auto d-flex justify-content-center  row ">
              <div className="col-6  d-flex justify-content-start">
                {" "}
                <button className="btn btn-success btn_font">Bank 2</button>
              </div>
              <div className="col-6 d-flex justify-content-end">
                {" "}
                <button className="btn btn-success btn_font">
                  Tager Code B2
                </button>
              </div>
            </div>

            <div className=" box_container">
              {/* Bank 1 */}
              {!transactionSubmitted ? (
                <div className="form-wrapper">
                  <h2 className="fund-transfer-heading">Fund Transfer</h2>
                  <p className="from-account-text">
                    From Account: {formData.fromAccount}
                  </p>
                  <form onSubmit={handleSubmit} className="styled-form">
                    <label>
                      Transfer to:
                      <select
                        name="toAccount"
                        value={formData.toAccount}
                        onChange={handleChange}
                        required>
                        <option value="">Select Account</option>
                        {toAccounts.map((account) => (
                          <option key={account} value={account}>
                            {account}
                          </option>
                        ))}
                      </select>
                    </label>

                    <label className="amount-label">
                      Amount:
                      <div className="input-with-symbol">
                        <input
                          type="text"
                          name="amount"
                          value={formData.amount}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow only if value is not "0"
                            if (value === "0") {
                              //alert("Amount cannot be 0!");
                              return;
                            }

                            // Update the state if valid
                            handleChange(e);
                          }}
                          autoComplete="off"
                        />
                        <span className="symbol-overlay">₹</span>
                      </div>
                    </label>

                    <div>
                      <span>Transaction Mode:</span>
                      <div className="button-group">
                        {["IMPS", "NEFT", "RTGS"].map((mode) => (
                          <button
                            key={mode}
                            type="button"
                            className={`transaction-mode-btn ${formData.transactionMode === mode
                              ? "selected"
                              : ""
                              }`}
                            onClick={() =>
                              setFormData({
                                ...formData,
                                transactionMode: mode,
                              })
                            }>
                            {mode}
                          </button>
                        ))}
                      </div>
                    </div>

                    <button type="submit" style={{ fontFamily: "sans-serif" }}>
                      Transfer
                    </button>

                    {/* {responseMessage &&
                      responseMessage.includes("Insufficient balance") && (
                        <div className="error-message">{responseMessage}</div>
                      )} */}
                  </form>
                </div>
              ) : (
                <div className="transaction-details-center">
                  <div
                    className={`response ${responseMessage === "Transaction successful"
                      ? "success"
                      : ""
                      }`}>
                    <h1
                      className={
                        responseMessage === "Transaction successful"
                          ? "success-text"
                          : ""
                      }>
                      {responseMessage}
                    </h1>
                    {responseMessage === "Transaction successful" && (
                      <img
                        src={successImage}
                        alt="Success"
                        className="success-icon"
                      />
                    )}
                    {transferredAmount && (
                      <p className="transferred-amount">
                        Amount Transferred: ₹{" "}
                        {formatNumberWithCommas(transferredAmount.toString())}
                      </p>
                    )}

                    {referenceNumber && (
                      <p className="reference-number">
                        Transaction Reference Number:{" "}
                        <span>{referenceNumber}</span>
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-1 d-flex align-items-center">
          <div className="horizondal_arrow_container21 d-flex justify-content-center">
            <div className="arrow-and-data">
              &#8594; <br /> &#8592;
              {box1Data.tag2 && (
                <div className="tag-response1to2b">J43-yui208456-qwer</div>
              )}
              {box1Data.amountTransferred2 && (
                <div className="amount-transferred1to2">
                  ₹ {formatNumberWithCommas(box1Data.amountTransferred2)}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="col-5">
          <div className="box_wrp">
            <div className=" top_btn_wrp1 mx-auto d-flex justify-content-center  row ">
              <div className="col-6  d-flex justify-content-start">
                {" "}
                <button className="btn btn-success btn_font">Bank 3</button>
              </div>
              <div className="col-6 d-flex justify-content-end">
                {" "}
                <button className="btn btn-success btn_font">
                  Tager Code B3
                </button>
              </div>
            </div>

            <div className="box_container">
              {/* {transactionDetails.accountNumber && ( */}
              <div className="transaction-container">
                <div className="transaction-details">
                  <p>
                    <strong>Account Number:</strong>{" "}
                    <span className="value1">
                      {transactionDetails.accountNumber}
                    </span>
                  </p>
                  <p className="center-text" style={{ marginLeft: "26px" }}>
                    <strong>Available Balance</strong>
                  </p>

                  <div className="balance-value">
                    <span className="value">
                      {" "}
                      ₹{" "}
                      {formatNumberWithCommas(
                        transactionDetails.availableBalance.toString()
                      )}
                    </span>
                  </div>
                </div>
              </div>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="tager_engine_box_wrp1">
            <div>
              <div className="arrow_vertical_wrp">
                ↑ &nbsp; &nbsp; ↓
                <div className="">
                  <p>API</p>
                </div>
              </div>

              <div className="tager_engine_box">
                <h5>Tager Engine Information</h5>
                {box1Data.tag2 ? (
                  <>
                    <p>
                      Loop Tag:{" "}
                      <span className="valuenew">J43-yui208456-qwer</span>
                    </p>
                    <p>
                      Account:{" "}
                      <span className="value">{box1Data.account2}</span>
                    </p>
                    <p>
                      Amount Transferred:{" "}
                      <span className="value">
                        {" "}
                        ₹ {formatNumberWithCommas(box1Data.amountTransferred2)}
                      </span>
                    </p>
                    <p>
                      Tag Type:{" "}
                      <span className="value">{box1Data.tagType2}</span>
                    </p>
                    <p>
                      Tag Validity: <span className="value">1 hour</span>
                    </p>
                  </>
                ) : (
                  <p></p> // Show a placeholder or loading text before data is available
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-1 d-flex align-items-center">
          <div className="horizondal_arrow_container31 d-flex justify-content-center">
            <div
              className="arrow-and-data2"
              style={{ position: "relative", marginTop: "20px" }}>
              &#8594;
              <br /> &#8592;
              {/* Ensure the API text is always displayed */}
              <div
                className="text-container"
                style={{
                  position: "relative", // Allows vertical adjustment
                  top: "-20px", // Moves the text slightly upward
                  textAlign: "center", // Centers the text horizontally
                  fontSize: "24px", // Sets the font size
                  marginLeft: "10px",
                }}>
                <p>API</p>
              </div>
              {/* Conditional content rendering */}
              {box1Data.tag2 && (
                <div className="tag-response1to2bottomv">
                  J43-yui208456-qwer
                </div>
              )}
              {box1Data.amountTransferred2 && (
                <div className="amount-transferred1to2bottom">
                  ₹ {formatNumberWithCommas(box1Data.amountTransferred2)}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-5">
          <div className="tager_engine_box_wrp1">
            <div>
              <div className="arrow_vertical_wrp">
                ↑ &nbsp; &nbsp; ↓
                <div className="">
                  <p>API</p>
                </div>
              </div>

              <div className="tager_engine_box">
                <h5>Tager Engine Information</h5>
                {box2Data.tag3 ? (
                  <>
                    <p>
                      Loop Tag:{" "}
                      <span className="valuenew">J43-yui208456-qwer</span>
                    </p>
                    <p>
                      Account:{" "}
                      <span className="value">{box2Data.account3}</span>
                    </p>
                    <p>
                      Amount Transferred:{" "}
                      <span className="value">
                        ₹ {formatNumberWithCommas(box2Data.amountTransferred3)}
                      </span>
                    </p>
                    <p>
                      Tag Type:{" "}
                      <span className="value">{box2Data.tagType3}</span>
                    </p>
                    <p>
                      Tag Validity: <span className="value">1 hour </span>
                    </p>
                  </>
                ) : (
                  <p></p> // Show a placeholder or loading text before data is available
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        {/* Separate boxes below each half */}

        <div className="button-container">
          <button
            className={`circle-button ${status === "success" ? "green" : "red"
              }`}
            onClick={handleTruncate}
            disabled={loading} // Disable button while loading
          >
            {loading ? (
              <span className="loader">...</span> // Show loader
            ) : status === "success" ? (
              <FaCheckCircle />
            ) : null}{" "}
            {/* No text */}
          </button>

          <button
            className={`circle-button2 ${status1 === "success" ? "green" : "red"
              }`}
            onClick={handleInsert}
            disabled={loading1} // Disable button while loading
          >
            {loading1 ? (
              <span className="loader">...</span> // Show loader
            ) : status1 === "success" ? (
              <FaCheckCircle />
            ) : null}{" "}
            {/* No text */}
          </button>
        </div>
      </div>
    </>
  );
}

export default BankTransfer2to3new;
